module.exports = __webpack_public_path__ + "img/profile.359ee8bd.svg";